class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();

    let show_cartdrawer = document.querySelectorAll('.show_cartdrawer')
    let new_add_cart_button = document.querySelectorAll('.new_add_cart_button')

    
    new_add_cart_button.forEach(item=>{
      item.addEventListener('click', (e) => {
        e.preventDefault();
        let valueid = 45020395766044
        const formData = new FormData();
        formData.append('id', valueid);
        formData.append('sections', 'cart-drawer');
        fetch('https://it.shokz.com/cart/add', {
          method: 'POST',
          body: formData
        })
        .then(response => response.text())
        .then(data => {
          const html = new DOMParser().parseFromString(data, 'text/html');
          const sourceQty = html.querySelector('#cart-icon-bubble');
          const totals__subtotal_value = html.querySelector('.totals__subtotal-value');
          if (this.querySelector('.cart-items tbody')) {
            this.querySelector('.cart-items tbody').innerHTML = html.querySelector('.cart-items tbody').innerHTML;
            this.querySelector('.totals__subtotal-value').innerHTML = totals__subtotal_value.innerHTML;
          }else{
            console.log('购物车空')
            console.log()
            this.classList.remove('is-empty')
            this.querySelector("#CartDrawer .drawer__inner").innerHTML = html.querySelector("#CartDrawer .drawer__inner").innerHTML
          }
          document.querySelector('#cart-icon-bubble').innerHTML = sourceQty.innerHTML
          this.classList.add('animate', 'active')
        })
        .catch(error => {
          console.error('Error:', error);
        });
      });
    })
     // div[data-variantid]
show_cartdrawer.forEach(item => {
  item.addEventListener('click', (e) => {
    e.preventDefault();
    
    let valueid = item.parentNode.parentNode.parentNode.parentNode.querySelector('.part1 .variant-buttons').dataset.variantid;
    const formData = new FormData();

    // Append the primary variant ID
    formData.append('items[0][id]', valueid);
    formData.append('items[0][quantity]', 1);

    // Find additional variant inputs, if any, and append their IDs
    const additionalVariantInputs = item.parentNode.parentNode.parentNode.querySelectorAll('input[name="additional_variant_id"]');
    additionalVariantInputs.forEach((input, index) => {
      if (input.value) {
        formData.append(`items[${index + 1}][id]`, input.value);
        formData.append(`items[${index + 1}][quantity]`, 1);
      }
    });

    const bdditionalVariantInputs = item.parentNode.parentNode.querySelectorAll('input[name="additional_variant_id"]');
    bdditionalVariantInputs.forEach((input, index) => {
      if (input.value) {
        formData.append(`items[${index + 1}][id]`, input.value);
        formData.append(`items[${index + 1}][quantity]`, 1);
      }
    });
    
    fetch(`${routes.cart_add_url}`, {
      method: 'POST',
      body: formData
    })
    .then(response => response.text())
    .then(data => {
      const html = new DOMParser().parseFromString(data, 'text/html');
      const sourceQty = html.querySelector('#cart-icon-bubble');
      const totals__subtotal_value = html.querySelector('.totals__subtotal-value');

      if (this.querySelector('.cart-items tbody')) {
        this.querySelector('.cart-items tbody').innerHTML = html.querySelector('.cart-items tbody').innerHTML;
        this.querySelector('.totals__subtotal-value').innerHTML = totals__subtotal_value.innerHTML;
      } else {
        console.log('购物车空');
        this.classList.remove('is-empty');
        this.querySelector("#CartDrawer .drawer__inner").innerHTML = html.querySelector("#CartDrawer .drawer__inner").innerHTML;
      }

      document.querySelector('#cart-icon-bubble').innerHTML = sourceQty.innerHTML;
      this.classList.add('animate', 'active');
    })
    .catch(error => {
      console.error('Error:', error);
    });
  });
})
  }
  onCartUpdate() {
  }
  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
